import { render, staticRenderFns } from "./ObjetivosWindowLI.vue?vue&type=template&id=b343435e&scoped=true&"
import script from "./ObjetivosWindowLI.vue?vue&type=script&lang=js&"
export * from "./ObjetivosWindowLI.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b343435e",
  null
  
)

export default component.exports